import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'taskCalendar';

const taskCalendarService = {
  getCalendarDays: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default taskCalendarService;
